import { Container } from "./styles";
import { LoadingSpinnerProps } from "./types";

export function LoadingSpinner({ size, thickness }: LoadingSpinnerProps) {
  return <Container size={size} thickness={thickness}></Container>;
}
